<template>
  <v-card>
    <template v-if="showModal">
      <v-layout class="pa-2">
        <v-flex style="align-self: center;"></v-flex>
        <v-flex xs12 sm6 class="form-control text-xs-right" style="display: inherit;">
          <div class="input-icons">
            <i class="fa fa-search icon"></i>
            <input
              @keyup.enter="
                pageNumberIntent = 1
                getIntent()
              "
              type="text"
              v-model="searchIntent"
              class="form-control"
              :placeholder="$t('Search Conversation Name')"
              style="margin-bottom: 10px"
            />
            <v-btn v-show="searchIntent.length > 0" @click="clearSearch" icon class="icon-close">
              <i class="fa fa-close"></i
            ></v-btn>
          </div>
          <v-btn
            @click="
              pageNumberIntent = 1
              tabSelect = 'isEdit'
              getIntent()
            "
            color="primary"
          >
            {{ $t('Search') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider />
      <v-card-text style="max-height: 600px; min-height: 213px;">
        <v-layout class="mt-2 mb-2 " v-if="!loadingIntent">
          <v-flex>
            <v-btn color="primary" :outline="tabSelect === 'isNew'" @click="tabSelect = 'isEdit'">
              {{ $t('add_existing') }}</v-btn
            >
            <v-btn
              :outline="tabSelect === 'isEdit'"
              color="primary"
              class="ml-2"
              @click="tabSelect = 'isNew'"
            >
              {{ $t('create_new') }}</v-btn
            >
          </v-flex>
          <v-flex class="text-xs-right">
            <v-pagination
              v-if="tabSelect === 'isEdit'"
              :total-visible="showsize"
              v-model="pageNumberIntent"
              @input="getIntent"
              :length="pageCountIntent"
            ></v-pagination>
          </v-flex>
        </v-layout>

        <div class="spinner text-xs-center" v-if="loadingIntent">
          <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
        </div>
        <div v-else>
          <ul
            class="training-data"
            style="margin: 0; padding: 0"
            v-if="!loadingIntent && tabSelect === 'isEdit'"
          >
            <li
              class="item z-border-red"
              v-for="(intent, index) in filterIntents"
              :key="'intent_' + index"
              @click="addTrainingToConversation(intent)"
            >
              {{ intent.intentname }}
            </li>
          </ul>
        </div>
        <div class="mt-2 mb-2 text-xs-right" v-if="tabSelect === 'isEdit'">
          <v-pagination
            :total-visible="showsize"
            v-model="pageNumberIntent"
            @input="getIntent"
            :length="pageCountIntent"
          ></v-pagination>
        </div>

        <div class="mt-2 mb-2" v-if="tabSelect === 'isNew'">
          <div style="width: 100%" class="form-control">
            <label>{{ $t('conversation_name') }}</label>
            <input type="text" v-model="intentName" :disabled="loading" small />
          </div>
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" outline depressed @click="$emit('update:showModal', false)">{{
          $t('cancel')
        }}</v-btn>
        <v-btn
          v-if="tabSelect === 'isNew'"
          color="primary"
          depressed
          @click="addTrainingToConversation({ intentname: intentName })"
          >{{ $t('Save') }}</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: ['value', 'showModal'],
  data: function() {
    return {
      intentName: this.value.intentname,
      tabSelect: 'isEdit',
      pageNumberIntent: 1,
      isShow: false,
      showsize: 15,
      pageCountIntent: 1,
      pageNumber: 1,
      size: 50,
      loading: false,
      loadingIntent: true,
      intents: [],
      search: '',
      searchIntent: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    filterIntents: function() {
      const vm = this
      vm.intents.sort(function(a, b) {
        const nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        const nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        // names must be equal
        return 0
      })

      return vm.intents
    }
  },
  mounted() {
    const vm = this
    vm.getIntent()
  },
  methods: {
    clearSearch() {
      const vm = this
      vm.searchIntent = ''
      vm.getIntent()
    },
    addTrainingToConversation: async function(intent) {
      let vm = this
      vm.$emit('input', intent)
      vm.$emit('update:showModal', false)
    },

    getIntent() {
      let vm = this
      vm.loadingIntent = true
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.showsize,
        offset: (vm.pageNumberIntent - 1) * vm.showsize,
        page_intent: 'conversation',
        search_intent: vm.searchIntent || '',
        sort_by: 'intentname',
        sort_type: 'asc'
      }
      vm.intents = []
      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            vm.pageCountIntent = Math.ceil(response.total_count / vm.showsize)

            const intents = response.data.map(val => {
              let intent = val
              intent.isShow = false
              intent.ableToDelete = true
              if (intent.intentname == '{default}') {
                intent.ableToDelete = false

                vm.default_intent = intent
              } else {
                return intent
              }
            })
            vm.intents = intents
          }
          vm.loadingIntent = false
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.color-black {
  color: rgb(0, 0, 0);
}
.primaryButton {
  margin-left: 0;
  margin-right: 0;
}
.intentmax {
  font-size: 22px;
}
.input-icons {
  display: contents;
  i {
    position: absolute;
  }
  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }
  .icon {
    padding: 16px;
    min-width: 50px;
  }
  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/ChatGptSelectIntent.vue